import { type ReactNode } from 'react'
import { Link as InertiaLink, usePage } from '@inertiajs/react'

import { PageLayout } from '@components/layouts/PageLayout'
import type { SettingsHeader } from '@components/layouts/PageHeaderIsland'
import { PageHeaderNav } from '@molecules/PageHeaderNav'
import { SectionNav, type SectionNavLinks } from '@molecules/SectionNav'

// Every Configurations controller shares settingsHeader and sections (inertia_share).
type SharedProps = { settingsHeader: SettingsHeader; sections: SectionNavLinks }

export function ConfigurationsLayout({ children }: { children: ReactNode }) {
  const { settingsHeader, sections } = usePage<SharedProps>().props
  const { heading, subtitle, icon, pageTabs } = settingsHeader

  return (
    <PageLayout.Root>
      <PageLayout.Header
        heading={heading}
        icon={icon}
        subtitle={subtitle}
        nav={
          pageTabs && <PageHeaderNav ariaLabel={pageTabs.label} items={pageTabs.items} linkComponent={InertiaLink} />
        }
      />
      <PageLayout.Body>
        <div className="tw:flex tw:flex-col tw:gap-6 tw:md:flex-row tw:md:items-start">
          <SectionNav ariaLabel={sections.label} items={sections.items} linkComponent={InertiaLink} />
          <div className="tw:flex tw:min-w-0 tw:max-w-3xl tw:grow tw:flex-col tw:gap-8">{children}</div>
        </div>
      </PageLayout.Body>
    </PageLayout.Root>
  )
}
